import { render, staticRenderFns } from "./messwarn.vue?vue&type=template&id=5a924c0a&"
import script from "./messwarn.vue?vue&type=script&lang=js&"
export * from "./messwarn.vue?vue&type=script&lang=js&"
import style0 from "./messwarn.vue?vue&type=style&index=0&id=5a924c0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports